var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.72266 2.2966L22.4375 22.139","stroke":"white","strokeWidth":"4","key":0}),React.createElement("line",{"x1":"22.0778","y1":"19.7561","x2":"2.14116","y2":"40.8279","stroke":"white","strokeWidth":"4","key":1})]);
}

ChevronRight.defaultProps = {"width":"24","height":"43","viewBox":"0 0 24 43","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
